(function () {
  'use strict';

  angular
      .module('localization')
      .config(config);

  function config($translateProvider) {

    var data = {
      invest: {
        "signInvestment": "Potpiši investiciju",
        "headerNew": "Nova investicija",
        "accountFrom": "S računa",
        "amountInputLabel": "Iznos",
        "quantityInputLabel": "Količina",
        "accountTo": "Isplata na račun",
        "date":"Datum vrednovanja",
        "dateNewOrder":"Datum vrednovanja",
        "dueDate": "Datum vrednovanja",
        "amountPlaceholder": "eg. 1,000.00",
        "accountType": "Vrsta računa",
        "fundName": "Naziv fonda",
        "fundNameReplace": "Fond za zamjenu",
        "comment": "Napomena",
        "bellowComment":"Podnositelj Zahtjeva potvrđuje da je upoznat s ",
        "bellowComment2": "Prospektom, Pravilima i Ključnim informacijama za ulagatelje fonda za koji podnosi Zahtjev",
        "bellowComment3": "  i da dokumente u cijelosti prihvaća.",
        "investor": "Investitor",
        "loan": "Kredit",
        "buyingFond": "Fond kupnje",
        "sellingFond": "Fond prodaje",
        "replacementFond": "Fond zamjene",
        "note": "Napomena",
        "back": "Natrag",
        "amountMinAmountError": "Pogrešan iznos ulaganja.",
        "amountMinAmountError2": "Minimalni iznos ulaganja za odabrani fond je 100,00 Kn.",
        "buyInvestmentPopup1": "Ovom transakcijom otvarate novi račun u fondu {{invFund}}",
        "buyInvestmentPopup2": "Da li želite nastaviti unos?",
        "add":"Potvrdi",
        "alertInfoNoFund": "Ne postoji investicija za odabrani račun.",
        "amountTypeAllShares": "Svi udjeli",
        "amountTypeShareValue": "Vrijednost udjela",
        "amountTypeShareQuantity": "Količina udjela",
        "accounts": "Računi"
      },
      investOverview: {
        "totalShareValue": "Ukupna vrijednost udjela",
        "shareQuantity": " Količina udjela",
        "buyStocks": "Kupnja udjela",
        "sellStocks": "Prodaja udjela",
        "replaceStocks": "Zamjena udjela",
        "transactions": "Transakcije",
        "orders": "Nalozi",
        "sharedAccount": "Zajednički račun:",
        "invAmount": "Iznos investicije:",
        "invDate": "Datum investicije:",
        "buyAccount": "Korisnički račun:",
        "fundName": "Naziv fonda:",
        "noTransactionData": "Nema dostupnih transakcija.",
        "noOrderData": "Nema dostupnih naloga.",
        "shareAccount": "Račun udjela",
        "dateOfEntry": "Datum knjiženja",
        "shareValue": "Vrijednost udjela",
        "shareQuant": "Količina udjela",
        "chargeValue": "Vrijednost naknade",
        "fundType": "Vrsta fonda",
        "sharePrice": "Cijena udjela",
        "copyOrder": "Kopiraj nalog",
        "editOrder": "Promijeni nalog",
        "deleteOrder": "Izbriši nalog",
        "signOrder": "Potpiši nalog",
        "status_created": "Kreiran",
        "status_recalled": "Opozvan",
        "status_processed": "Obrađen",
        "status_rejected": "Odbijen",
        "status_closed": "Zatvoren",
        "status_signed": "Potpisan",
        "status_inProcess": "U Obradi",
        "status_canceled": "Storniran"
      },
      investmentsList: {
        invOverview: "Pregled investicijskih računa",
        "shareQuantity": "Količina dionica"
      },
      accessInvestment: {
        "accession": "Pristupnica investicijskom fondu",
        "nameSurname": "Ime i prezime",
        "address": "Adresa prebivališta",
        "identificationNumber": "Broj identifikacijske isprave",
        "issuer": "Izdavatelj",
        "phone": "Telefon",
        "emailNotification": "Slanje obavjesti E-mailom",
        "bank": "Banka",
        "paymentAccNumber": "Broj računa",
        "plannedYearInvestment": "Planirane godišnje investicije",
        "fundsInvestment": "Sredstva za ulaganje ostvarena su od dohotka od",
        "msg1": "Potpisom ovog Upitnika potvrđujem da su u njemu navedeni podaci istiniti te ovlašćujem društvo Addiko Invest d.d.(dalje Društvo) da provjeri sve ovdje navedene podatke." +
        " Osobno ću vas obavijestiti ukoliko dođe do promjena vezanih uz prije izjavljene podatke i detalje.",
        "msg2": "Potpisom ovog Upitnika dajem izričitu suglasnost Društvu da može poduzimati sve radnje vezano na obradu i razmjenu mojih osobnih podataka navedenih u ovom Upitniku, uključujući i podatak o matičnom broju građana, a što obuhvaća pravo Društva na prikupljanje, spremanje, snimanje, organiziranje, uvid i prijenos osobnih podataka u svrhu obavljanja redovitih poslova Društva.",
        "employee": "Zaposlenik",
        "firm": "Poduzetnik",
        "unemployed": "Nezaposlen",
        "retired": "Umirovljenik",
        "student": "Student",
        "rest": "Ostalo",
        "personalStatus": "Osobni status",
        "employer": "Vrsta poslodavaca",
        "privateSector": "Privatni sektor",
        "civileService": "Državna služba",
        "stateAuth": "Tjela državne/lokalne vlasti",
        "emplTrade": "Državna trgovačka društva",
        "vocation": "Zvanje",
        "profession": "Zanimanje",
        "invEmployment": "Nesamostalni rad",
        "invfreelancing": "Samostalna djelatnost",
        "invLegal": "Imovina i imovinska prava",
        "capital": "Kapital",
        "invInsured": "Osiguranje",
        "inv1": "Do 200.000 kn",
        "inv2": "Do 500.000 kn",
        "inv3": "Do 1.000.000 kn",
        "inv4": "Više od 1.000.000 kn",
        "accountNumberInput": "Broj računa za isplatu",
        "add": "Dodaj"
      },
      salesReplacementTranslation: {
        title: "Poslovanje sa investicijskim fondovima"
      }
    };

    $translateProvider
        .translations('hr', data);

  }
}());
